import {
  Component,
  ChangeDetectionStrategy,
  Inject,
  OnInit,
} from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA
} from '@angular/material/legacy-dialog';
import { MatDividerModule } from '@angular/material/divider';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { UiModule } from '../../../ui/ui.module';

import { UiEmptyPageStandaloneComponent } from '../../../ui/components/ui-empty-page/ui-empty-page.component';
import { trackByValue } from '../../util';
import { IFieldConfig } from '../../interfaces';

@Component({
  selector: 'lum-timeline-list-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    UiEmptyPageStandaloneComponent,
    UiModule,
    MatDividerModule,
    MatLegacyButtonModule,
  ],
  templateUrl: './timeline-list-dialog.component.html',
  styleUrls: ['./timeline-list-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineListDialogComponent implements OnInit {
  viewModel: {
    date: string;
    title: string;
    subtitle: string;
  }[] = [];
  trackByValue = trackByValue;
  title: string = 'Timeline List';

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: {
      title: string,
      items: any[],
      fieldMap: {
        date: IFieldConfig;
        title: IFieldConfig;
        subtitle: IFieldConfig;
      }
    },
    public dialogRef: MatDialogRef<TimelineListDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.title = this.data?.title || 'Timeline List';
    this.viewModel = this.data?.items?.map((item) => ({
      title: this.resolveField(item, this.data?.fieldMap?.title),
      subtitle: this.resolveField(item, this.data?.fieldMap?.subtitle),
      date: this.resolveField(item, this.data?.fieldMap?.date),
    }));
  }

  private resolveField(item: any, config: IFieldConfig): string {
    let value = config.path.split('.').reduce((acc, key) => acc?.[key], item);

    if (value === undefined || value === null) {
      return config.fallback || '';
    }

    if (config.transform) {
      try {
        return config.transform(value, item);
      } catch {
        return config.fallback || '';
      }
    }

    if (config.type === 'date') {
      return new Date(value).toISOString();
    }

    return value;
  }
}
